"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateRequest = exports.transformDateResponse = exports.DateFormat = void 0;
const luxon_1 = require("luxon");
var DateFormat;
(function (DateFormat) {
    DateFormat[DateFormat["YYYY-MM-DD"] = 0] = "YYYY-MM-DD";
    DateFormat[DateFormat["YYYY-MM-DD hh:mm:ss"] = 1] = "YYYY-MM-DD hh:mm:ss";
    DateFormat[DateFormat["YYYY-MM-DDThh:mm:ss"] = 2] = "YYYY-MM-DDThh:mm:ss";
})(DateFormat = exports.DateFormat || (exports.DateFormat = {}));
const transformDateResponse = (dateString, dateFormat = DateFormat['YYYY-MM-DD'], timeZone = 'America/New_York') => {
    switch (dateFormat) {
        case DateFormat['YYYY-MM-DD hh:mm:ss']:
            return luxon_1.DateTime.fromSQL(dateString, { zone: timeZone }).toJSDate();
        case DateFormat['YYYY-MM-DDThh:mm:ss']:
            dateString = dateString.replace(/([^Z])$/, '$1Z'); // Append Z if not present
            return luxon_1.DateTime.fromISO(dateString).toJSDate();
        default:
            return new Date(`${dateString} 00:00:00`);
    }
};
exports.transformDateResponse = transformDateResponse;
const transformDateRequest = (date) => {
    if (typeof date === 'string') {
        date = new Date(date);
    }
    const year = date.getFullYear();
    const month = date.toLocaleDateString(undefined, { month: '2-digit' });
    const day = date.toLocaleDateString(undefined, { day: '2-digit' });
    return `${year}-${month}-${day}`;
};
exports.transformDateRequest = transformDateRequest;
//# sourceMappingURL=Date.js.map